/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-02 17:31:39
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-11-17 16:59:28
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  getOrgList: (id, params) => request({
    url: `${requestUrl}/organization/${id}`,
    method: "get",
    params
  }),
  getOrgLists: data => request({
    url: `${requestUrl}/organization/search`,
    method: "post",
    data
  }),
  changeOrg: data => request({
    url: `${requestUrl}/auth/login-with-org`,
    method: "post",
    data
  }),
  // 获取部门用户列表
  getDepartmentList: (id, params) => request({
    url: `${requestUrl}/user/org/${id}/org-user`,
    method: "get",
    params
  }),
  getOrgUserList: id => request({
    url: `${requestUrl}/user/org/${id}`,
    method: "get"
  }),
  orgAssignUser: (id, data) => request({
    url: `${requestUrl}/user/org/${id}`,
    method: "patch",
    data
  }),
  getUserList: params => request({
    url: `${requestUrl}/user/page?penetrateOrg=true&withRole=true`,
    method: "get",
    params
  }),
  // 获取用户
  getUserPage(params, headers = {}) {
    return request({
      url: `${requestUrl}/user/page`,
      method: "get",
      params,
      headers
    });
  },
  getUserListByIds: ids => request({
    url: `${requestUrl}/user/search`,
    method: "post",
    data: { keys: ids }
  }),
  userAssignRole: (id, data) => request({
    url: `${requestUrl}/user/${id}/role`,
    method: "patch",
    data
  }),

  /**
   * @description: 查询租户下用户
   * @param {*}
   * @return {*}
   */
  getOrgAllUser: params => request({
    url: `${requestUrl}/user/tenant-users`,
    method: "get",
    params
  }),
  // 根据id查询用户详情
  getDetailsById: params => request({
    url: `${requestUrl}/user/${params}`,
    method: "get"
  }),
  // 以下为用户管理新的接口
  addUser: data => request({
    url: `${requestUrl}/user`,
    method: "post",
    data
  }),
  editUser: data => request({
    url: `${requestUrl}/user`,
    method: "put",
    data
  }),
  // 根据id查询用户详情
  getDetailsByIdNew: params => request({
    url: `${requestUrl}/user/infos/${params}`,
    method: "get"
  }),
  // 重置密码
  resetItems: data => request({
    url: `${requestUrl}/user/restpassword`,
    method: "put",
    data
  }),
  // 删除
  deleteItems: params => request({
    url: `${requestUrl}/user/${params}`,
    method: "delete"
  }),
  // 是否有效
  setEffect: data => request({
    url: `${requestUrl}/user/effect`,
    method: "put",
    data
  }),
  exportUser: params => request({
    url: `${requestUrl}/user/export`,
    responseType: "blob",
    method: "get",
    params
  }),
  encrypt: data => request({
    url: `${requestUrl}/auth/encrypt`,
    method: "post",
    data
  }),
  changePassword: data => request({
    url: `${requestUrl}/auth/change-password`,
    method: "post",
    data
  }),
  syncUser: data => request({
    url: `${requestUrl}/tenant/platform/user`,
    method: "post",
    data
  }),
  getThirdPartyUser: params => request({
    url: `${requestUrl}/third-party/user/page`,
    method: "get",
    params
  }),
  synchroThirdPartyUser: (data, orgId) => request({
    url: `${requestUrl}/user/third-party/sync?targetDeptId=${orgId}`,
    method: "post",
    data
  }),
  // 获取用户绑定的钉钉
  getBindDDUser: params => request({
    url: `${requestUrl}/ding/auth/getDingTalkAppIds`,
    method: "get",
    params
  }),
  // 解除绑定
  closeBind: data => request({
    url: `${requestUrl}/ding/auth/unbinding`,
    method: "post",
    data
  })
};
export default api;
